import { Alert } from 'antd';
import React from 'react';
import { Company } from '../../models/company-interface';
import { Subscription } from '../../models/subscription-interface';
import moment from 'moment';
import { GetDateFormateStr } from '../../utilites/dateTimeHelper';
interface CompanyAlertProps {
  company: Company | undefined;
  isLoading: boolean;
  subscription: Subscription | undefined;
}

export default function CompanyAlert({
  company,
  isLoading,
  subscription,
}: CompanyAlertProps) {
  if (isLoading || !company) return null;

  if (company.deleted || !!company.deletedDate)
    return <Alert type='error' showIcon message='This company has been deleted.' />;

  if (!!!company.hasDatabase)
    return (
      <Alert type='info' showIcon message='Waiting for database to be created...' />
    );

  const disabled = !company.confirmed ? true : false;
  if (disabled) {
    if (!!subscription?.plans?.find(x => x.isBaseProduct)?.contractEffectiveDate) {
      const effectiveDate = new Date(subscription.plans?.find(x => x.isBaseProduct)?.contractEffectiveDate ?? new Date());
      if (effectiveDate > new Date()) {
        return (
          <Alert
            type='info'
            showIcon
            message={<>
              This company is disabled. It will become active on its contract effective date&nbsp;
              <b>{effectiveDate.toLocaleDateString()}</b>
            .</>}
          />
        );
      }
    }

    if (!!company.disabledDate) {
      const disabledDate = new Date(company.disabledDate);
      const now = new Date();
      const timeSinceDisabled = now.getTime() - disabledDate.getTime();
      const daysSinceDisabled = Math.floor(
        timeSinceDisabled / (1000 * 3600 * 24)
      );
      const daysUntilDeleted = 30 - daysSinceDisabled;
      const deletionMessage =
        daysSinceDisabled >= 30
          ? 'It is currently pending deletion.'
          : `It will be deleted in ${daysUntilDeleted} days.`;
      const manuallyDisabled = company.manuallyDisabled
        ? 'manually disabled'
        : 'disabled by Salesforce';

      return (
        <Alert
          type='error'
          showIcon
          message={`This company was ${manuallyDisabled} ${disabledDate.toLocaleDateString()}. ${deletionMessage}`}
        />
      );
    }

    return <Alert type='error' showIcon message='This company has been disabled.' />;
  }

  return null;
}
